import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';
import { LoadingAbsoluteService } from '../services/loading-absolute.service';
import { environment } from 'src/environments/environment';

const API_MAIN = environment.segurity + environment.host + environment.version + environment.typeService;


@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  
  private excludedUrls: string[] = [
      API_MAIN + "economic-activity-api/get-all",
      API_MAIN + "commercial-advisor-api/get-all",
      API_MAIN + "bank-api/get-all",
      API_MAIN + "province-api/get-all",
      API_MAIN + "city-api/get-all",
      API_MAIN + "tracking-api/get-products",
      API_MAIN + "tracking-api/calculate-sales-price",
  ];

  constructor(private loadingService: LoadingService, private loadingAbsoluteService: LoadingAbsoluteService) {}

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (this.isUrlExcluded(request.url)) {
      return next.handle(request);
    }

    if (
      request.url.includes(API_MAIN + "tracking-api/get-customer-information") ||
      request.url.includes( API_MAIN + "tracking-api/status")
    ) {

      this.loadingAbsoluteService.show();
      return next.handle(request).pipe(
        finalize(async () => {
          await this.delay(2000);
          this.loadingAbsoluteService.hide();
        })
      );
    } else {
      this.loadingService.show();
      return next.handle(request).pipe(
        finalize(() => {
          this.loadingService.hide();
        })
      );
    }
  }

  private isUrlExcluded(url: string): boolean {
    return this.excludedUrls.some(excludedUrl => url.startsWith(excludedUrl));
  }
}